import {
  RANGE_SENSITIVITY_SPREADSHEET_COMPANY_SECTION_HEADER,
  RANGE_SENSITIVITY_SPREADSHEET_ENTERPRISE_VALUE,
  RANGE_SENSITIVITY_SPREADSHEET_EQUITY_VALUE,
  RANGE_SENSITIVITY_SPREADSHEET_FUND_ROW,
} from 'pages/ValuationsAllocation/common/constants/rangeSensitivity/sheetAliases';
import { getArrayValue, getNumberValue, getObjectValue } from 'utilities';
import { CreateColumns, RangeSensitivityColumn } from './types';

const createColumns: CreateColumns = params => {
  const { rangeSensitivity, allocation, weightedShareValues } = params;

  const pct = getNumberValue(rangeSensitivity?.sensitivity_percentage);

  // Column 1: Sensitivity Range (stored as whole-number percentage, e.g. 10 for 10%)
  const sensitivityPctColumn: RangeSensitivityColumn = {
    [RANGE_SENSITIVITY_SPREADSHEET_COMPANY_SECTION_HEADER]: { value: pct * 100 },
  };

  // Column 2: Lower Bound (Calculated via expression, but we provide base data if needed)
  const lowerBoundColumn: RangeSensitivityColumn = {};

  // Column 3: Concluded Value (Pulled from API data)
  const concludedValueColumn: RangeSensitivityColumn = {
    [RANGE_SENSITIVITY_SPREADSHEET_EQUITY_VALUE]: {
      value: getNumberValue(allocation?.current_equity_value),
    },
    [RANGE_SENSITIVITY_SPREADSHEET_ENTERPRISE_VALUE]: {
      value: getNumberValue(allocation?.enterprise_value),
    },
  };

  // Fund rows keyed by `${RANGE_SENSITIVITY_SPREADSHEET_FUND_ROW}_${fund.id}`
  getArrayValue(weightedShareValues)?.forEach(wsv => {
    const fund = getObjectValue(wsv.fund);
    if (fund?.id) {
      const fundTotal = getArrayValue(wsv.share_values)?.reduce(
        (acc, sv) => acc + getNumberValue(sv.unrealized_value),
        0
      );
      concludedValueColumn[`${RANGE_SENSITIVITY_SPREADSHEET_FUND_ROW}_${fund.id}`] = { value: fundTotal };
    }
  });

  // Share value rows use expressions to equity allocation; no column seed values needed.

  // Column 4: Upper Bound (Calculated via expression)
  const upperBoundColumn: RangeSensitivityColumn = {};

  return [
    sensitivityPctColumn,
    lowerBoundColumn,
    concludedValueColumn,
    upperBoundColumn,
  ];
};

export default createColumns;
